/**
 * PMX — Schermate Black (sections/pmx-bf-stack.liquid) — PARMAX
 * Web Component <pmx-stack>. Scorrimento "a senso unico" (reel):
 * - le schermate sono "tappe" in colonna (dal 30/10/2026 SOLO le schermate: vedi REEL_SECTIONS;
 *   le regole qui sotto su sezioni alte/basse valgono solo se il reel sulle sezioni viene riattivato);
 * - scendendo, la prima tappa non ancora vista arriva a scatto
 *   (desktop "Copertura": la nuova sale sopra la precedente, che resta ferma e si oscura;
 *    mobile/touch: reel che segue il dito);
 * - le tappe gia' viste scorrono liberamente: risalendo nessuno scatto;
 * - sezioni piu' alte dello schermo: dentro si scorre libero, lo scatto arriva quando si e' in fondo;
 * - sezioni basse (sotto il 40% dello schermo): unite alla successiva in un'unica tappa;
 * - il footer non partecipa; a ogni ingresso nella pagina (anche col tasto indietro) l'effetto riparte.
 * Fluidita': lo scatto muove gli elementi con transform (scheda grafica, non la pagina);
 * a fine corsa la pagina si riallinea in un colpo solo (stessa immagine, nessun salto).
 * Attivo solo se la sezione e' la prima della pagina, senza "Riduci movimento" e fuori dal Theme Editor.
 * Emette 'pmx:stack' su document con { index, total, tone }.
 */
(() => {
  if (customElements.get('pmx-stack')) return;

  const TOUCH_MQ = window.matchMedia('(max-width: 767.98px), (hover: none)');
  const REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)');
  const EASE = 'cubic-bezier(.65, 0, .35, 1)'; // rotella, tastiera
  const EASE_OUT = 'cubic-bezier(.22, .61, .36, 1)'; // rilascio del dito
  const SHORT = 0.4; // sezioni sotto il 40% dello schermo: unite alla successiva
  // Reel esteso alle sezioni sotto le schermate (griglie, Storia...): DISATTIVATO il 30/10/2026 su richiesta
  // (sulle griglie risultava scattoso). Il reel resta solo sulle schermate; il codice resta pronto: true = riattiva.
  const REEL_SECTIONS = false;
  const html = document.documentElement;
  const clamp01 = (v) => Math.min(1, Math.max(0, v));

  class PmxStack extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      this.speed = parseInt(this.dataset.speed || '900', 10);
      this.track = this.querySelector('.pmx-stack__track');

      const section = this.closest('.shopify-section');
      const main = document.getElementById('main-content');
      this.section = section;
      this.main = main;
      this.isFirst = !!(section && main && main.firstElementChild === section);
      const editor = !!(window.Shopify && window.Shopify.designMode);
      this.enabled = this.isFirst && !REDUCE.matches && !editor && !!this.track;

      this.seen = 0;
      this.active = -1;
      this.anim = null;
      this.stops = [];
      this.tops = [];
      this.secEls = [];
      this.lastSnapEnd = 0;
      this.lastWheel = 0;
      this.touchEnd = 0;
      this.t = null;
      this.vw = window.innerWidth;

      ['measure', 'refresh', 'onScroll', 'update', 'onResize', 'onWheel', 'onKey', 'onTouchStart', 'onTouchMove', 'onTouchEnd']
        .forEach((f) => { this[f] = this[f].bind(this); });

      this.refresh();
      this.initTiles();
      this.classList.add('is-ready');
      this.measure();
      this.update();

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize);
      window.addEventListener('load', () => { this.measure(); this.onScroll(); this.prep(); });
      if ('ResizeObserver' in window) {
        // barra promo, Trustindex, griglie che si riempiono dopo: ricalcolo le tappe
        const ro = new ResizeObserver(() => { if (!this.anim) { this.measure(); this.onScroll(); } });
        document.querySelectorAll('.shopify-section-group-header-group').forEach((s) => ro.observe(s));
        if (this.enabled) ro.observe(this.main);
      }
      if (TOUCH_MQ.addEventListener) TOUCH_MQ.addEventListener('change', () => { this.refresh(); this.measure(); });

      // Rientro con il tasto indietro (pagina dalla cache del browser): l'effetto riparte
      window.addEventListener('pageshow', (e) => {
        if (!e.persisted) return;
        this.finish(true);
        this.measure();
        this.active = -1;
        const y = window.scrollY + window.innerHeight * 0.5;
        let a = 0;
        this.tops.forEach((t, i) => { if (t <= y) a = i; });
        this.seen = a;
        this.stops.forEach((s, i) => { if (i > a && s.slide) s.els[0].classList.remove('is-seen'); });
        this.update();
      });

      if (this.enabled) {
        window.addEventListener('wheel', this.onWheel, { passive: false });
        window.addEventListener('keydown', this.onKey);
        // ascolto il dito solo dove serve: un touchmove non passivo su tutta la pagina rallenta lo scroll ovunque
        const zone = REEL_SECTIONS ? this.main : this;
        zone.addEventListener('touchstart', this.onTouchStart, { passive: true });
        zone.addEventListener('touchmove', this.onTouchMove, { passive: false });
        zone.addEventListener('touchend', this.onTouchEnd);
        zone.addEventListener('touchcancel', this.onTouchEnd);
      }

      // Theme Editor: selezionando un blocco si va alla sua schermata
      document.addEventListener('shopify:block:select', (e) => {
        if (!this.contains(e.target)) return;
        const i = this.slides.indexOf(e.target.closest('[data-slide]'));
        if (i > -1) { this.measure(); window.scrollTo(0, this.tops[i]); }
      });
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      window.removeEventListener('wheel', this.onWheel);
      window.removeEventListener('keydown', this.onKey);
    }

    /* Su mobile la barra degli indirizzi cambia solo l'altezza: nessun ricalcolo pesante */
    onResize() {
      if (this.anim) return;
      if (window.innerWidth !== this.vw) {
        this.vw = window.innerWidth;
        this.refresh();
      }
      this.measure();
      this.onScroll();
    }

    /* Schermate visibili per il dispositivo corrente (lo split ha versioni desktop/mobile) e sezioni sotto */
    refresh() {
      const all = [...this.querySelectorAll('[data-slide]')];
      this.slides = all.filter((s) => getComputedStyle(s).display !== 'none');
      all.forEach((s) => s.classList.remove('is-lead'));
      if (this.slides[0]) this.slides[0].classList.add('is-lead');
      this.slides.forEach((s, i) => { s.style.zIndex = String(i + 1); });
      const touch = TOUCH_MQ.matches;
      this.classList.toggle('is-touch', touch);
      this.cover = this.enabled && !touch && !this.classList.contains('pmx-stack--slide');
      this.classList.toggle('is-cover', this.cover);

      if (this.enabled) {
        // tutte le sezioni del contenuto sotto le schermate (il footer e' fuori da #main-content)
        this.secEls = REEL_SECTIONS ? [...this.main.children].filter((el) => el !== this.section && el.classList.contains('shopify-section')) : [];
        this.unitEls().forEach((el, i) => {
          el.classList.toggle('pmx-unit', this.cover);
          el.style.zIndex = this.cover ? String(i + 1) : '';
          if (!this.cover) el.style.top = '';
        });
        this.section.classList.toggle('pmx-unit--stack', this.cover && REEL_SECTIONS);
        this.main.classList.add('pmx-reel');
        this.main.classList.toggle('pmx-reel-cover', this.cover && REEL_SECTIONS);
        this.main.style.setProperty('--pmx-dim', (getComputedStyle(this).getPropertyValue('--pmx-dim') || '.45').trim());
      }
      this.buildDots();
    }

    /* Posizione di ogni tappa (schermate + sezioni). Lo sticky della copertura falserebbe le misure:
       lo tolgo per un istante (nessun disegno nel mezzo, quindi nessuno sfarfallio). */
    measure() {
      const sy = window.scrollY;
      const vh = window.innerHeight;
      const cover = this.cover;
      const units = this.unitEls();
      if (cover) {
        this.classList.remove('is-cover');
        if (REEL_SECTIONS) this.main.classList.remove('pmx-reel-cover');
        units.forEach((el) => { el.style.top = ''; }); // le sezioni del tema sono position:relative
      }

      const top0 = Math.round(this.getBoundingClientRect().top + sy);
      const top = this.isFirst ? Math.max(0, top0) : 0;
      if (this._top !== top) {
        this._top = top;
        this.style.setProperty('--pmx-top', `${top}px`);
      }
      const stops = (this.slides || []).map((s) => ({ els: [s], slide: true, top: Math.round(s.getBoundingClientRect().top + sy) }));
      this.slidesBottom = Math.round(this.getBoundingClientRect().bottom + sy);

      if (this.enabled) {
        const secs = this.secEls
          .filter((el) => el.offsetHeight > 0)
          .map((el) => ({ el, top: Math.round(el.getBoundingClientRect().top + sy) }));
        const mainBottom = Math.round(this.main.getBoundingClientRect().bottom + sy);
        secs.forEach((s, i) => { s.h = (i + 1 < secs.length ? secs[i + 1].top : mainBottom) - s.top; });
        let pending = null;
        secs.forEach((s) => {
          if (pending) {
            pending.els.push(s.el);
            pending.h += s.h;
            if (pending.h >= vh * SHORT) { stops.push(pending); pending = null; }
            return;
          }
          const u = { els: [s.el], slide: false, top: s.top, h: s.h };
          if (s.h < vh * SHORT) pending = u; else stops.push(u);
        });
        if (pending) stops.push(pending);
        // copertura: ogni sezione si ferma quando il suo fondo tocca il fondo dello schermo
        if (cover) {
          units.forEach((el) => { el.style.top = `${Math.min(0, Math.round(vh - el.offsetHeight))}px`; });
        }
      }

      if (cover) { this.classList.add('is-cover'); if (REEL_SECTIONS) this.main.classList.add('pmx-reel-cover'); }
      this.stops = stops;
      this.tops = stops.map((s) => s.top);
    }

    /* Elementi che diventano "tappe" sticky nella copertura desktop: solo con il reel sulle sezioni */
    unitEls() {
      return this.enabled && REEL_SECTIONS ? [this.section, ...this.secEls] : [];
    }

    /* Categorie su mobile = carosello orizzontale (CSS): linea di avanzamento sotto, mossa dallo scorrimento.
       Su desktop la griglia non scorre e la linea resta nascosta. Funziona anche senza il reel. */
    initTiles() {
      this.querySelectorAll('.pmx-tiles__grid').forEach((grid) => {
        if (grid._pmxBar) return;
        const bar = document.createElement('div');
        bar.className = 'pmx-tiles__progress';
        bar.setAttribute('aria-hidden', 'true');
        bar.innerHTML = '<span></span>';
        grid.after(bar);
        grid._pmxBar = bar;
        const fill = bar.firstChild;
        let raf = 0;
        const upd = () => {
          raf = 0;
          const max = grid.scrollWidth - grid.clientWidth;
          bar.hidden = max <= 1;
          if (max <= 1) return;
          const vis = grid.clientWidth / grid.scrollWidth;
          const p = Math.min(1, Math.max(0, grid.scrollLeft / max));
          fill.style.width = `${(vis * 100).toFixed(2)}%`;
          fill.style.transform = `translateX(${((1 / vis - 1) * 100 * p).toFixed(2)}%)`;
        };
        grid.addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(upd); }, { passive: true });
        window.addEventListener('resize', upd);
        if ('ResizeObserver' in window) new ResizeObserver(upd).observe(grid);
        upd();
      });
    }

    buildDots() {
      const wrap = this.querySelector('[data-pmx-dots]');
      if (!wrap) return;
      wrap.innerHTML = '';
      if (this.slides.length < 2) return;
      this.slides.forEach((_, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.tabIndex = -1;
        b.addEventListener('click', () => {
          if (this.anim) return;
          this.measure();
          const y = window.scrollY;
          if (this.enabled && i > this.seen && this.tops[i] > y && this.tops[i] - y <= window.innerHeight * 1.05) this.slideTo(i);
          else { this.markSeen(i); window.scrollTo({ top: this.tops[i], behavior: 'smooth' }); }
        });
        wrap.appendChild(b);
      });
    }

    onScroll() {
      if (this._raf) return;
      this._raf = requestAnimationFrame(this.update);
    }

    /* Tappa attiva, viste, oscuramento copertura, indicatori */
    update() {
      this._raf = 0;
      if (!this.stops.length || this.anim) return;
      const y = window.scrollY;
      const vh = window.innerHeight;
      // Mobile: lo slancio del dito (da tappe gia' viste) non deve far saltare quelle non viste
      if (this.enabled && !this.t && this.classList.contains('is-touch')
        && performance.now() - this.touchEnd < 1500) {
        const n = this.seen + 1;
        if (n < this.stops.length && y > this.tops[n] - vh * 0.6) { this.slideTo(n, { hold: true }); return; }
      }
      const mid = y + vh * 0.5;
      let a = 0;
      this.tops.forEach((t, i) => { if (t <= mid) a = i; });
      if (a !== this.active) {
        this.active = a;
        this.slides.forEach((s, i) => s.classList.toggle('is-active', i === a));
        this.markSeen(a);
        const cur = this.stops[a];
        if (cur && cur.slide) this.dataset.tone = cur.els[0].dataset.tone || 'light';
        this.querySelectorAll('[data-pmx-dots] button').forEach((d, i) => d.classList.toggle('is-active', i === a));
        this.dispatch();
      }
      if (this.cover) {
        this.stops.forEach((s, i) => {
          const next = this.tops[i + 1];
          const p = next === undefined ? 0 : clamp01(1 - (next - y) / vh);
          s.els.forEach((el) => this.setCov(el, p));
        });
      }
      const inview = this.tops.length && this.tops[0] < mid && this.slidesBottom > mid;
      this.classList.toggle('is-inview', !!inview);
      this.classList.toggle('is-moved', y > (this.tops[0] || 0) + 40 || this.seen > 0);
    }

    setCov(el, p) {
      const v = p.toFixed(3);
      if (el._cov !== v) { el._cov = v; el.style.setProperty('--pmx-cov', v); }
    }

    markSeen(i) {
      for (let k = 0; k <= i; k++) {
        const s = this.stops[k];
        if (s && s.slide) s.els[0].classList.add('is-seen');
      }
      if (i > this.seen) this.seen = i;
    }

    dispatch() {
      document.dispatchEvent(new CustomEvent('pmx:stack', {
        detail: { index: this.active, total: this.stops.length, tone: this.dataset.tone }
      }));
    }

    /* Prossima tappa verso il basso, se non ancora vista e se quella attuale e' gia' visibile fino
       in fondo (altrimenti -1: scorrimento libero) */
    targetDown() {
      const y = window.scrollY;
      // la prima schermata parte sotto header/Trustindex: si cerca dalla seconda in poi
      const n = this.tops.findIndex((t, i) => i > 0 && t > y + 2);
      if (n < 0 || n <= this.seen) return -1;
      if (this.tops[n] - y > window.innerHeight + 2) return -1; // sezione alta: prima la si scorre
      return n;
    }

    /* Elementi che si muovono: in "Copertura" solo la nuova tappa, altrimenti la colonna intera */
    movers(n) {
      const s = this.stops[n];
      if (this.cover) return s.els;
      if (s.slide) return [this.track];
      // sezioni: muovo solo cio' che si vede durante lo scatto (tappa attuale + nuova), non tutta la pagina:
      // un livello grafico di migliaia di pixel con le foto delle griglie rende lo scatto "scattoso" sul telefono
      const sy = window.scrollY;
      const lo = sy;
      const hi = this.tops[n] + window.innerHeight;
      const els = [...this.slides, ...this.secEls].filter((el) => {
        const h = el.offsetHeight;
        if (!h) return false;
        const t = el.getBoundingClientRect().top + sy;
        return t + h > lo + 2 && t < hi - 2; // 2px: escludo gli elementi solo sfiorati
      });
      return els.length ? els : [this.main];
    }

    /* Inizio di uno scatto verso la tappa n (anche da trascinamento) */
    begin(n, opts = {}) {
      this.measure();
      const from = window.scrollY;
      const max = document.documentElement.scrollHeight - window.innerHeight;
      const to = Math.max(0, Math.min(max, this.tops[n]));
      const els = this.movers(n);
      this.anim = { n, from, to, d: to - from, els, hold: !!opts.hold, offset: 0 };
      if (opts.hold) { html.classList.add('pmx-snap-hold'); html.style.overflow = 'hidden'; }
      this.hdrSnap(true); // l'header si toglie insieme allo scatto
      this.classList.add('is-snapping');
      if (els[0] === this.main) this.classList.add('is-snapping-main');
      els.forEach((el) => { el.style.willChange = 'transform'; });
      return this.anim;
    }

    setOffset(a, y, transition) {
      a.els.forEach((el) => {
        el.style.transition = transition;
        el.style.transform = `translate3d(0, ${y}px, 0)`;
      });
    }

    /* Porta il movimento a destinazione (go = true) o lo annulla (go = false) */
    run(go, dur, ease) {
      const a = this.anim;
      if (!a) return;
      const target = go ? -a.d : 0;
      if (go) {
        // i testi della nuova schermata entrano durante lo scatto
        this.markSeen(a.n);
        this.slides.forEach((s, i) => s.classList.toggle('is-active', i === a.n));
      }
      const ms = `${Math.round(dur)}ms`;
      this.style.setProperty('--pmx-run', ms);
      this.main.style.setProperty('--pmx-run', ms);
      this.classList.add('is-running');
      if (this.cover) this.main.classList.add('pmx-reel-running'); // classe su main = ricalcolo di tutte le sezioni: solo se serve
      if (this.cover && a.n > 0) this.stops[a.n - 1].els.forEach((el) => this.setCov(el, go ? 1 : 0));
      const lead = a.els[0];
      const end = (e) => {
        if (e && (e.target !== lead || e.propertyName !== 'transform')) return;
        lead.removeEventListener('transitionend', end);
        clearTimeout(a.wd);
        this.finish(go);
      };
      lead.addEventListener('transitionend', end);
      a.wd = setTimeout(end, dur + 120); // scheda in background: si completa comunque
      requestAnimationFrame(() => {
        if (this.anim !== a) return;
        this.setOffset(a, target, `transform ${Math.round(dur)}ms ${ease}`);
        if (Math.abs(a.offset - target) < 1) end();
      });
    }

    /* Fine scatto: tolgo il transform e allineo la pagina nello stesso istante */
    finish(go) {
      const a = this.anim;
      if (!a) return;
      this.anim = null;
      a.els.forEach((el) => {
        el.style.transition = '';
        el.style.transform = '';
        el.style.willChange = '';
      });
      (this._prepped || []).forEach((el) => { el.style.willChange = ''; });
      this._prepped = [];
      if (go) window.scrollTo({ top: a.to, behavior: 'instant' });
      this.prep();
      if (a.hold) { html.style.overflow = ''; html.classList.remove('pmx-snap-hold'); }
      this.classList.remove('is-snapping', 'is-snapping-main', 'is-running');
      if (this.cover) this.main.classList.remove('pmx-reel-running');
      this.lastSnapEnd = performance.now();
      if (!go) this.slides.forEach((s, i) => s.classList.toggle('is-active', i === this.active));
      this.active = -1;
      this.update();
      // l'header resta nascosto finche' pmx-bf.js non registra lo scorrimento
      setTimeout(() => this.hdrSnap(false), go ? 160 : 0);
    }

    /* Preparazione in anticipo: a pagina ferma metto su un livello grafico proprio gli elementi che si
       muoveranno al prossimo scatto, cosi' quando parte il gesto il telefono li ha gia' pronti. */
    prep() {
      if (!this.enabled) return;
      clearTimeout(this._prepT);
      this._prepT = setTimeout(() => {
        if (this.anim) return;
        const n = this.seen + 1;
        const next = n < this.stops.length && !this.stops[n].slide ? this.movers(n) : [];
        (this._prepped || []).forEach((el) => { if (!next.includes(el)) el.style.willChange = ''; });
        next.forEach((el) => { el.style.willChange = 'transform'; });
        this._prepped = next;
      }, 250);
    }

    /* Header nascosto durante lo scatto: classe sull'header (non su <html>, che ricalcolerebbe tutta la pagina) */
    hdrSnap(on) {
      if (!this._hdr) this._hdr = document.querySelector('.cc-header');
      if (this._hdr) this._hdr.classList.toggle('pmx-snap-hide', on);
    }

    slideTo(n, opts) {
      if (this.anim) return;
      this.begin(n, opts);
      const dur = (this.classList.contains('is-touch') ? this.speed * 0.7 : this.speed)
        * Math.min(1, Math.max(0.5, Math.abs(this.anim.d) / window.innerHeight));
      this.run(true, dur, EASE);
    }

    /* ---------- Rotella / trackpad ---------- */
    onWheel(e) {
      if (!this.stops.length || e.ctrlKey) return;
      if (Math.abs(e.deltaY) < Math.abs(e.deltaX)) return;
      const now = performance.now();
      const gap = now - this.lastWheel;
      this.lastWheel = now;
      if (this.anim) { e.preventDefault(); return; }
      if (e.deltaY <= 0) return; // risalita: sempre libera
      const n = this.targetDown();
      if (n < 0) return;
      e.preventDefault();
      // coda d'inerzia del trackpad subito dopo uno scatto: la assorbo
      if (now - this.lastSnapEnd < 1200 && gap < 140) return;
      if (Math.abs(e.deltaY) < 3) return;
      this.slideTo(n);
    }

    onKey(e) {
      if (!this.stops.length) return;
      const t = e.target;
      if (t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT|BUTTON)$/.test(t.tagName))) return;
      const down = ['ArrowDown', 'PageDown'].includes(e.key) || (e.key === ' ' && !e.shiftKey);
      if (!down) return;
      if (this.anim) { e.preventDefault(); return; }
      const n = this.targetDown();
      if (n < 0) return;
      e.preventDefault();
      this.slideTo(n);
    }

    /* ---------- Touch: reel che segue il dito, solo verso tappe non viste ---------- */
    onTouchStart(e) {
      this.t = null;
      if (!this.stops.length || e.touches.length > 1 || this.anim) return;
      const p = e.touches[0];
      this.t = { x: p.clientX, y: p.clientY, time: performance.now(), lastY: p.clientY, lastT: performance.now(), v: 0, axis: null, n: -1 };
    }

    onTouchMove(e) {
      const t = this.t;
      if (!t) { if (this.anim) e.preventDefault(); return; }
      const p = e.touches[0];
      const dx = p.clientX - t.x;
      const dy = p.clientY - t.y;
      if (!t.axis) {
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        t.axis = Math.abs(dy) > Math.abs(dx) ? 'y' : 'x';
        if (t.axis === 'x' || dy > 0) { this.t = null; return; } // orizzontale o risalita: nativo
        this.measure();
        t.n = this.targetDown();
        if (t.n < 0) { this.t = null; return; } // tappa gia' vista o sezione alta: nativo
        this.begin(t.n);
        this.setOffset(this.anim, 0, 'none');
      }
      e.preventDefault();
      const a = this.anim;
      if (!a) return;
      const now = performance.now();
      t.v = (p.clientY - t.lastY) / Math.max(1, now - t.lastT);
      t.lastY = p.clientY;
      t.lastT = now;
      a.offset = Math.max(-a.d, Math.min(0, dy));
      this.setOffset(a, a.offset, 'none');
      if (this.cover && a.n > 0) this.stops[a.n - 1].els.forEach((el) => this.setCov(el, -a.offset / a.d));
    }

    onTouchEnd() {
      const t = this.t;
      this.t = null;
      this.touchEnd = performance.now();
      const a = this.anim;
      if (!t || !t.axis || t.n < 0 || !a) return;
      const passed = -a.offset > Math.min(90, a.d * 0.12) || t.v < -0.35;
      const rest = passed ? a.d + a.offset : -a.offset;
      const base = this.speed * 0.7;
      const dur = Math.max(220, Math.min(base, base * (rest / Math.max(1, a.d)) * 1.2));
      this.run(passed, dur, EASE_OUT);
    }
  }

  customElements.define('pmx-stack', PmxStack);
})();
